import { setNewClientApi } from '@/repository/config'
import { getApiURL } from '@/repository/config/api-url'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const { $cookieStore, $i18n } = nuxtApp as any
  const baseURL = getApiURL({ locale: $i18n.locale.value, config })
  const showSsrLog = config.public.ssrLog === 'true'

  const { clientApi } = setNewClientApi({
    baseURL,
    cookies: $cookieStore,
    fetcher: useCustomFetch,
    showSsrLog,
  })

  return {
    provide: {
      apiClient: clientApi.httpClient,
    },
  }
})
